import { Injectable } from '@angular/core';
import { RequestBase } from './request-base';
import { Observable } from 'rxjs';

@Injectable()
export class OAuthService extends RequestBase {
    BasePath = 'api/oauth';

    GetOAuthURL(id: string, handlerKey: string): Observable<string> {
        const path = this.API_BASE_URL + this.BasePath + '/GetOAuthURL?id=' + id + '&handlerKey=' + handlerKey;
        return this.http.get<string>(path, this.options);
    }

    GetRedirectURL(): Observable<string> {
        return this.http.get<string>(this.API_BASE_URL + this.BasePath + '/GetRedirectURL', this.options);
    }
}
